/*
 * @Author: Alan
 * @Date: 2023-02-16 15:34:36
 * @LastEditors: Alan
 * @LastEditTime: 2023-02-21 09:28:48
 * @Description: 头部注释
 * @FilePath: \F1-M1-WEB-Code\components\OTP\ReadMore.js
 */
import React from "react";
import { Row, Col, Button } from "antd";

function ReadMore({ VerifyCategory, setReadStep }) {
    return (
        <React.Fragment>
            <Row>
                <Col span={24}>
                    <img
                        className="otp-modal-banner"
                        src="/cn/img/user/otpVerify/otp-banner.jpg"
                        alt=""
                    />
                    <div className="otp-modal-description">
                        <div>亲爱的玩家，</div>
                        <br />
                        <div>
                            为了维持最高的服务标准，我们正在不断升级我们的系统。
                            目前，我们需要进行进一步升级数据安全系统，需要您帮助来验证您的电话号码或电子邮件，以确保是您本人登录。
                        </div>
                        <br />
                        <p style={{ margin: 0 }}>
                            为了进一步保护您的信息，我们将需要您通过短信或电子邮件身份验证您的登录信息。
                            您登录后，我们会将6位数的验证码发送到账户绑定的电话或电子邮件，
                            您可以通过在网页或客户端上输入6位数验证码来验证您的帐户。
                            如果您无法确认电话号码或电子邮件地址，请联系我们在线客户服务，随时为您提供协助。
                        </p>
                        <br />
                        <p>
                            我们全体员工将竭尽全力保护您的个人信息，我们希望得到您的理解与支持。
                        </p>
                        <p style={{ margin: 0 }}>谢谢</p>
                    </div>
                </Col>
            </Row>

            <Button
                size="large"
                className="otpBtn readMore securityAnnouncement"
                onClick={() => {
                    setReadStep(0);
                    Pushgtagdata("Back_loginOTP");
                }}
                block
            >
                进行验证
            </Button>
        </React.Fragment>
    );
}

export default ReadMore;
